import React, { useCallback,useState } from 'react';
import { FiClipboard } from 'react-icons/fi';

import { Icon } from '@/components/icon/icon';
import { Tooltip } from '@/components/tooltip/tooltip';

import styles from './invocationIdCell.module.scss';

type InvocationIdCellProps = {
  id: string;
};

export const InvocationIdCell: React.FC<InvocationIdCellProps> = ( { id } ) => {
  const [ copied, setCopied ] = useState( false );

  const copyToClipboard = useCallback( async() => {
    try {
      await navigator.clipboard.writeText( id );
      setCopied( true );
      window.setTimeout( () => setCopied( false ), 1200 );
    } catch { /** no op */ }
  }, [ id ] );

  const truncateId = ( fullId: string ) => {
    if ( !fullId ) return '';
    if ( fullId.length <= 20 ) return fullId;
    return `${ fullId.substring( 0, 17 ) }...`;
  };

  return (
    <div className={ styles.invocationIdCell }>
      <Tooltip content={ copied ? 'Copied!' : 'Copy ID' } position="top">
        {/* Not using Buttom component on purpose. No variant for icon button. */}
        <button
          type="button"
          onClick={ copyToClipboard }
          className={ styles.copyButton }
          aria-label="Copy ID"
        >
          <Icon icon={ FiClipboard } />
        </button>
      </Tooltip>
      <Tooltip content={ id } position="top">
        <span className={ styles.idText }>{ truncateId( id ) }</span>
      </Tooltip>
    </div>
  );
};
